<p-blockUI [blocked]="blocked">
    <i class="pi pi-lock" style="font-size: 4rem"></i>
</p-blockUI>
<p-toast></p-toast>
<p-toast key="tst" [style]="{marginTop: '70px'}"></p-toast>
<div class="card">
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>
    <div class="p-col-12">
        <div class="p-md-6 ">
            <div class="card view">
                <div class="p-fluid">
                    <!-- Input Country-->
                    <div class="p-col-12 p-m-2">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-2 church_field--label">
                                <label for="opt">{{translations.lbl_country}}</label>
                            </div>
                            <div class="p-col-12 p-md-10">
                                <p-dropdown [options]="countries" [(ngModel)]="selectedCountry" optionLabel="descrip"
                                    [showClear]="true" placeholder="{{translations.lbl_select}} {{translations.lbl_country}}" (onChange)="onChangeCountry()"
                                    ></p-dropdown>
                            </div>
                        </div>
                    </div>

                    <!-- Input State-->
                    <div class="p-col-12 p-m-2">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-2 church_field--label">
                                <label for="opt">{{translations.lbl_state}}</label>
                            </div>
                            <div class="p-col-12 p-md-10">
                                <p-dropdown [options]="listState" [(ngModel)]="selectedState" optionLabel="descrip"
                                    [showClear]="true" placeholder="{{translations.lbl_select}} {{translations.lbl_state}}"
                                    (onChange)="onChangeState()"></p-dropdown>
                            </div>
                        </div>
                    </div>

                    <!-- Input City-->
                    <div class="p-col-12 p-m-2">
                        <div class=" p-fluid p-formgrid p-grid church_field">
                            <div class="p-col-12 p-md-2 church_field--label">
                                <label for="opt">{{translations.lbl_city}}</label>
                            </div>
                            <div class="p-col-12 p-md-10">
                                <p-dropdown [options]="listCities" [(ngModel)]="selectedCity" optionLabel="value"
                                    [showClear]="true" placeholder="{{translations.lbl_select}} {{translations.lbl_city}}"
                                    (onChange)="onChangeCity()"></p-dropdown>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="p-md-12 ">
            <p-table #dt [value]="lstChurches" [rows]="10" [paginator]="true"
                [globalFilterFields]="['chr.name','chr.shortName','ab.city','ab.state','ab.neight','fromTime','ab.street','ab.zipCode','ab.tel1']"
                [(selection)]="selectedChurch" [rowHover]="true" dataKey="wrksId"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [showCurrentPageReport]="true">

                <ng-template pTemplate="caption" class="p-col-12 p-m-2">
                    <h5 class="church--title ">{{lbl_churchs_chapels_parish}}</h5>
                    <div class="p-fluid p-formgrid p-grid">
                        <!-- Input City-->
                        <div class="p-col-12 mb-2">
                            <div class=" p-fluid p-formgrid p-grid church_field">
                                <div class="p-col-12 p-md-6 church_field--label church_field--buttons">
                                    <button type="button" pButton pRipple icon="pi pi-plus" (click)="openNewChurch()"
                                        class="p-mr-4 z-5" pTooltip="{{lbl_new_record}}"
                                        tooltipPosition="bottom"></button>

                                    <button type="button" pButton pRipple icon="pi pi-file-excel"
                                        (click)="exportExcel()" class="p-button-success p-mr-2 z-5" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                    <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                                        class="p-button-warning p-mr-2" pTooltip="PDF"
                                        tooltipPosition="bottom"></button>
                                </div>
                                <div class="p-col-12 p-md-4">
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                        
                                            (input)="dt.filterGlobal($event.target.value, 'contains')"
                                            placeholder="{{translations.lbl_search}}..." />
                                    </span>
                                </div>
                            </div>
                        </div>

                    </div>
                </ng-template>

                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="chr.name">{{translations.lbl_type}}<p-sortIcon field="chr.name"></p-sortIcon></th>
                        <th pSortableColumn="chr.name">{{translations.lbl_name}}<p-sortIcon field="chr.name"></p-sortIcon></th>
                        <th pSortableColumn="ab.city">{{translations.lbl_street_and_number}} <p-sortIcon
                                field="ab.city"></p-sortIcon></th>
                        <th pSortableColumn="ab.neight">{{translations.lbl_neightborhood}}<p-sortIcon field="ab.neight"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ab.state">{{translations.lbl_zip_code}}<p-sortIcon field="ab.state"></p-sortIcon></th>
                        <th pSortableColumn="ab.city">{{translations.lbl_city}}<p-sortIcon field="ab.city"></p-sortIcon></th>
                        <th pSortableColumn="chrNumSer" *ngIf="!security || security && (security.levelId=='I'  || security.levelId=='Z')">No. Servs<p-sortIcon field="chrNumSer"></p-sortIcon></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-church>
                    <tr>
                        <td>{{church.chr.type}}</td>
                        <td>{{church.chr.name}}</td>
                        <td>{{church.ab.street}} </td>
                        <td>{{church.ab.neight}}</td>
                        <td>{{church.ab.zipCode}}</td>
                        <td>{{church.ab.city}}</td>
                        <td *ngIf="security.levelId=='I' || security.levelId=='Z'">{{church.chrNumSer}}</td>

                        <td>

                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                                (click)="openChurchDetail(church)" pTooltip="{{translations.lbl_edit}}" [disabled]="checEnableButtons(church)"></button>

                            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                                (click)="deleteChurch(church)" pTooltip="{{translations.lbl_delete}}" [disabled]="checEnableButtons(church)"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        Total {{lstChurches ? lstChurches.length : 0 }} churchs.
                    </div>
                </ng-template>
            </p-table>
        </div>


    </div>

    <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>